import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import ServiceDetail, { ServicesIndex } from "@/pages/Services";
import PartnerVisa from "@/pages/PartnerVisa";
import SkillsInDemand482 from "@/pages/SkillsInDemand482";
import PRAssessment from "@/pages/PRAssessment";
import PRAssessmentHub from "@/pages/PRAssessmentHub";
import StudentPRAssessment from "@/pages/StudentPRAssessment";
import PointsCalculator from "@/pages/PointsCalculator";
import BookConsultation from "@/pages/BookConsultation";
import { ResourcesIndex, ResourcePost } from "@/pages/Resources";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { PRAssessmentsAdmin, StudentPRAssessmentsAdmin, ConsultationsAdmin, MessagesAdmin, SkilledMigrationAdmin, GSBuilderAdmin } from "@/pages/admin/AdminSubmissions";
import AdminInbox from "@/pages/admin/AdminInbox";
import BlogManager from "@/pages/admin/BlogManager";
import AdminChatEnquiries from "@/pages/admin/AdminChatEnquiries";
import ServiceCharges from "@/pages/ServiceCharges";
import CitizenshipApplication from "@/pages/CitizenshipApplication";
import NationalInnovationVisa from "@/pages/NationalInnovationVisa";
import DamaVisas from "@/pages/DamaVisas";
import StudentFundsCalculator from "@/pages/StudentFundsCalculator";
import VisitorVisa600 from "@/pages/VisitorVisa600";
import VisaStatementBuilder from "@/pages/VisaStatementBuilder";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import DocumentChecklistTool from "@/pages/DocumentChecklistTool";
import SkilledMigrationAssessment from "@/pages/SkilledMigrationAssessment";
import ParentVisaFinder from "@/pages/ParentVisaFinder";
import ParentVisasHub from "@/pages/ParentVisasHub";
import TemporaryGraduate485 from "@/pages/TemporaryGraduate485";
import PathwayAssessment from "@/pages/PathwayAssessment";
import AgentPartnership from "@/pages/AgentPartnership";
import RmaNetwork from "@/pages/RmaNetwork";
import ReferFriend from "@/pages/ReferFriend";
import Graduate485Planner from "@/pages/Graduate485Planner";
import ArtReviews from "@/pages/ArtReviews";
import AdminAssessmentRules from "@/pages/admin/AdminAssessmentRules";
import ScrollToTop from "@/components/ScrollToTop";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/citizenship-application" element={<CitizenshipApplication />} />
            <Route path="/services/national-innovation-visa" element={<NationalInnovationVisa />} />
            <Route path="/services/dama-visas" element={<DamaVisas />} />
            <Route path="/services/visitor" element={<VisitorVisa600 />} />
            <Route path="/services/visitor-visa-subclass-600" element={<VisitorVisa600 />} />
            <Route path="/partner-visa" element={<PartnerVisa />} />
            <Route path="/services/family" element={<PartnerVisa />} />
            <Route path="/services/skills-in-demand-482" element={<SkillsInDemand482 />} />
            <Route path="/services/appeals" element={<ArtReviews />} />
            <Route path="/art-review" element={<ArtReviews />} />
            <Route path="/skills-in-demand-482" element={<SkillsInDemand482 />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/student-funds-calculator" element={<StudentFundsCalculator />} />
            <Route path="/student-fund-calculator" element={<StudentFundsCalculator />} />
            <Route path="/document-checklist" element={<DocumentChecklistTool />} />
            <Route path="/ai-skilled-visa-assessment" element={<SkilledMigrationAssessment />} />
            <Route path="/skilled-migration-assessment" element={<SkilledMigrationAssessment />} />
            <Route path="/parent-visa-finder" element={<ParentVisaFinder />} />
            <Route path="/ai-parent-visa-pathway-finder" element={<ParentVisaFinder />} />
            <Route path="/parent-visas" element={<ParentVisasHub />} />
            <Route path="/temporary-graduate-485" element={<TemporaryGraduate485 />} />
            <Route path="/services/graduate" element={<TemporaryGraduate485 />} />
            <Route path="/services/graduate-485" element={<TemporaryGraduate485 />} />
            <Route path="/graduate-visa" element={<TemporaryGraduate485 />} />
            <Route path="/ai-visa-statement-builder" element={<VisaStatementBuilder />} />
            <Route path="/visa-statement-builder" element={<VisaStatementBuilder />} />
            <Route path="/statement-builder" element={<VisaStatementBuilder />} />
            <Route path="/gs-builder" element={<VisaStatementBuilder />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/service-charges" element={<ServiceCharges />} />
            <Route path="/pricing" element={<ServiceCharges />} />
            <Route path="/pr-assessment" element={<PRAssessmentHub />} />
            <Route path="/pr-assessment/onshore" element={<StudentPRAssessment />} />
            <Route path="/pr-assessment/offshore" element={<PRAssessment />} />
            {/* Legacy aliases */}
            <Route path="/pr-assessment/general" element={<PRAssessment />} />
            <Route path="/pr-assessment/student" element={<StudentPRAssessment />} />
            <Route path="/points-calculator" element={<PointsCalculator />} />
            <Route path="/book-consultation" element={<BookConsultation />} />
            <Route path="/resources" element={<ResourcesIndex />} />
            <Route path="/resources/:slug" element={<ResourcePost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pathway-assessment" element={<PathwayAssessment />} />
            <Route path="/start" element={<PathwayAssessment />} />
            <Route path="/education-agent-partnership" element={<AgentPartnership />} />
            <Route path="/partner-with-us" element={<AgentPartnership />} />
            <Route path="/rma-network" element={<RmaNetwork />} />
            <Route path="/join-the-network" element={<RmaNetwork />} />
            <Route path="/refer" element={<ReferFriend />} />
            <Route path="/refer-a-friend" element={<ReferFriend />} />
            <Route path="/485-pathway-planner" element={<Graduate485Planner />} />
            <Route path="/graduate-485-planner" element={<Graduate485Planner />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/inbox" element={<AdminInbox />} />
            <Route path="/admin/pr-assessments" element={<PRAssessmentsAdmin />} />
            <Route path="/admin/student-pr-assessments" element={<StudentPRAssessmentsAdmin />} />
            <Route path="/admin/consultations" element={<ConsultationsAdmin />} />
            <Route path="/admin/messages" element={<MessagesAdmin />} />
            <Route path="/admin/skilled-migration" element={<SkilledMigrationAdmin />} />
            <Route path="/admin/gs-submissions" element={<GSBuilderAdmin />} />
            <Route path="/admin/chat-enquiries" element={<AdminChatEnquiries />} />
            <Route path="/admin/blog" element={<BlogManager />} />
            <Route path="/admin/assessment-rules" element={<AdminAssessmentRules />} />
          </Route>
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
